import { render, staticRenderFns } from "./static-chiose.vue?vue&type=template&id=f2581968&scoped=true"
import script from "./static-chiose.vue?vue&type=script&lang=js"
export * from "./static-chiose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2581968",
  null
  
)

export default component.exports